import { lazy } from 'react';

// ----------------------------------------------------------------------

const NomenclatureBindingPage = lazy(
  () =>
    import(
      /* webpackPreload: true */
      /* webpackChunkName: "NomenclatureDeduplicationPage" */
      '@/pages/nomenclature/binding/NomenclatureBindingPage'
    ),
);

export default NomenclatureBindingPage;
